import { IInquiryResponse, TInquiryStatus } from '@interfaces/inquiries';

const printAvailableStatuses = [TInquiryStatus.Complete, TInquiryStatus.New];

export const shouldShowPrintButton = (data: IInquiryResponse): boolean =>
  printAvailableStatuses.includes(data.inquiryStatusId) &&
  data.supplementInquiriesDto.some(item => item.isActive);
